import { call, put, takeEvery, take, select } from "redux-saga/effects";
import { eventChannel, END } from "redux-saga";
import { getProvider } from "@/providers";
import { getExpirationDate } from "@/helpers/date_helper";
/* Selector */
import { selectSignsByKey } from "./selectors";
// Redux Actions
import { ETH_PLAIN_SIGN_PROCESSED } from "@ensuro/ethereum-store";
import { SET_PROVIDER, SET_CHAIN_ID, SET_USER, SET_KYC_SIGNATURE } from "./actionTypes";

function providerListenerChannel(provider) {
  return eventChannel((emitter) => {
    /*if (provider.removeAllListeners)
      provider.removeAllListeners();*/
    provider.on("accountsChanged", (evtData) => {
      // Track Wallet can't emit this event, so it's always true
      emitter({ type: SET_USER, payload: evtData[0], canTransact: true });
    });

    provider.on("chainChanged", (evtData) => {
      emitter({ type: SET_CHAIN_ID, payload: parseInt(evtData, 16) });
    });

    provider.on("disconnect", () => {
      emitter({ type: SET_PROVIDER, payload: null });
      emitter(END);
    });
    return () => {};
  });
}

export function* listenToEvents({ payload }) {
  if (payload == null) return;
  const channel = yield call(providerListenerChannel, getProvider(payload));
  try {
    while (true) {
      let action = yield take(channel);
      yield put(action);
    }
  } finally {
    // Cleanup if needed
  }
}

export function* storeUser({ key, userAddress, signature, message }) {
  const state = yield select((state) => state.UserReducer);
  const sign = selectSignsByKey(state, key, userAddress);
  if (userAddress !== state.address) {
    // We want to ignore any call made by another address than the state one.
    return;
  }
  const args = sign.args;

  const kycSignature = {
    message: message,
    signature: signature,
    address: state.address,
    chainId: state.chainId,
    expiration: getExpirationDate(),
    email: args.email,
  };

  yield put({ type: SET_KYC_SIGNATURE, kycSignature });
}

export function* userSaga() {
  yield takeEvery(SET_PROVIDER, listenToEvents);
  yield takeEvery(ETH_PLAIN_SIGN_PROCESSED, storeUser);
}

export default userSaga;
